var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"i-con-h-a",attrs:{"to":{name: _vm.target, params: _vm.params}}},[_c('i',{staticClass:"i-con",class:{'i-con-edit': !_vm.viewLink, 'i-con-eye': _vm.viewLink}})])}
var staticRenderFns = []

export { render, staticRenderFns }